import { confirmAlert } from 'react-confirm-alert';
import { AlertModal, ConfirmModal, ContentsModal, ConfirmModal3 } from 'shared/view/Modal';
import CryptoJS from 'crypto-js';
import sanitizeHTML from 'sanitize-html';

//byte 체크
export const getByteLengthOfUtf8String = (s) => {
  let b;
  let c;
  let i;
  if (s !== undefined && s !== '' && s !== null) {
    for (b = i = 0; (c = s.charCodeAt(i++)); b += c >> 11 ? 3 : c >> 7 ? 2 : 1);
    return b;
  } else {
    return 0;
  }
};

// YYYYMMDD
export const transformDayFormatWithoutDash = (date, type) => {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  let newFormat
  if (type === 'month') {
    newFormat = `${year}${month}`
  } else {
    newFormat = `${year}${month}${day}`
  }
  return newFormat;
};

// Alert
export const reactAlert = (message, onClickClose, name, className) => {
  // message: 객체
  confirmAlert({
    customUI: ({ onClose }) => AlertModal(message, onClose, onClickClose, name, className),
    closeOnEscape: false,
    closeOnClickOutside: false,
  });
};

// Confirm
export const reactConfirm = (message, onOk, names, className, txtAlign, wide) => {
  confirmAlert({
    customUI: ({ onClose }) => ConfirmModal(message, onClose, onOk, names, className, txtAlign, wide),
    closeOnEscape: false,
    closeOnClickOutside: false,
  });
};

// Confirm
export const reactConfirm3 = (message, onApply, onChange, names, className, txtAlign) => {
  confirmAlert({
    customUI: ({ onClose }) => ConfirmModal3(message, onClose, onApply, onChange, names, className, txtAlign),
    closeOnEscape: false,
    closeOnClickOutside: false,
  });
};

// Contents
export const reactModal = (children, onOk, names, className, svcInfo) => {
  confirmAlert({
    customUI: ({ onClose }) => ContentsModal(onClose, onOk, names, className, children, svcInfo),
    closeOnEscape: false,
    closeOnClickOutside: false,
  });
};

// 일주일 전 날짜 구하기 YYYY-MM-DD
export const getDayAWeekAgo = () => {
  let day = new Date();
  let dayOfMonth = day.getDate();
  day.setDate(dayOfMonth - 7);

  return transformDayFormat(day);
};

// 주 시작일 구하기
export const getStartDayofWeek = () => {
  let value = '';
  const formatDate = function (date) {
    const myMonth = date.getMonth() + 1;
    const myWeekDay = date.getDate();

    const addZero = function (num) {
      if (num < 10) {
        num = '0' + num;
      }
      return num;
    };
    const md = `${addZero(myMonth)}-${addZero(myWeekDay)}`;

    return md;
  };
  const now = new Date();
  const nowDayOfWeek = now.getDay(); // sun~sat: 0~6
  const nowDay = now.getDate();
  const nowMonth = now.getMonth();
  let nowYear = now.getYear();

  nowYear += nowYear < 2000 ? 1900 : 0;

  // 일요일 오류 수정
  const weekStartDate = new Date(nowYear, nowMonth, nowDay + 1 - (nowDayOfWeek === 0 ? 7 : nowDayOfWeek));

  value = `${nowYear}-${formatDate(weekStartDate)}`;

  return value;
};

export const getStartDate = (type) => {
  let value = '';
  const formatDate = function (date) {
    const myMonth = date.getMonth() + 1;
    const myWeekDay = date.getDate();

    const addZero = function (num) {
      if (num < 10) {
        num = '0' + num;
      }
      return num;
    };
    const md = `${addZero(myMonth)}-${addZero(myWeekDay)}`;

    return md;
  };

  const now = new Date();
  const nowDayOfWeek = now.getDay(); // sun~sat: 0~6
  const nowDay = now.getDate();
  const nowMonth = now.getMonth();
  let nowYear = now.getYear();

  nowYear += nowYear < 2000 ? 1900 : 0;

  let startDate = '';
  if (type === 'w') {
    // 이번주 시작일
    startDate = new Date(nowYear, nowMonth, nowDay + 1 - nowDayOfWeek);
  } else if (type === 'm') {
    // 이번달 시작일
    startDate = new Date(nowYear, nowMonth, 1);
  } else {
    // type: c -> 기본 노출 두달전
    if (nowMonth - 2 < 0) {
      nowYear = nowYear - 1;
    }
    startDate = new Date(nowYear, nowMonth - 2, 1);
  }

  value = `${nowYear}-${formatDate(startDate)}`;

  return value;
};

// YYYY-MM-DD
export const transformDayFormat = (date) => {
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let day = date.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  let newFormat = `${year}-${month}-${day}`;
  return newFormat;
};

export const transformDayFormat2 = (date) => {
  let year = date.getFullYear();
  let month = date.getMonth();
  let day = date.getDate();
  if (month < 10) {
    month = `0${month}`;
  }
  if (day < 10) {
    day = `0${day}`;
  }

  let newFormat = `${year}-${month}-${day}`;
  return newFormat;
};

// YYYY-MM-DD -> date object
export const dateObject = (value) => {
  let dateStr = String(value);
  const sYear = dateStr.substring(0, 4);
  const sMonth = dateStr.substring(5, 7);
  const sDate = dateStr.substring(8, 10);

  return new Date(Number(sYear), Number(sMonth) - 1, Number(sDate));
};

export const dateObjectManu = (value) => {
  let dateStr = String(value);
  const sYear = dateStr.substring(0, 4);
  const sMonth = dateStr.substring(4, 6);
  const sDate = dateStr.substring(6, 8);

  return new Date(Number(sYear), Number(sMonth) - 1, Number(sDate));
};

// YYYYMMDD -> YYYY-MM-DD
export const dayFormatterCtype = (date) => {
  //let newFormat = `${date.substr(0, 4)}-${date.substr(4, 2)}-${date.substr(6, 2)}`;
  let newFormat = date.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
  return newFormat;
};

// YYYY.MM.DD (day) -> YYYYMMDD
export const timeBtypeConverter = (time) => {
  const regExp = /[ \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\ '\"\\(\=]/gi;

  let newFormat = time.replace(regExp, '');
  newFormat = `${newFormat.substr(0, 4)}${newFormat.substr(4, 2)}${newFormat.substr(6, 2)}`;

  return newFormat;
};

// 날짜만 얻어오기 YYYY-MM-DD
export const getDateString = (date) => {
  //
  return date.substring(0, 10);
};

export const getShortDateString = (date) => {
  //
  return date.substring(5, 10);
};

export const checkInputSystemInfos = (sysInfos) => {
  //
  let focusInput = null;

  // return true ==> break, return false ==> continue

  sysInfos.forEach((sysInfo, sysIdx) => {
    if (!sysInfo.sysOsNm || sysInfo.sysOsNm.length < 1) {
      focusInput = `sysOsNm-${sysIdx}`;
      return true;
    }
    if (!sysInfo.sysSvrNm || sysInfo.sysSvrNm.length < 1) {
      focusInput = `sysSvrNm-${sysIdx}`;
      return true;
    }
    if (!sysInfo.sysHostNm || sysInfo.sysHostNm.length < 1) {
      focusInput = `sysHostNm-${sysIdx}`;
      return true;
    }

    sysInfo.realiplist.forEach((ipInfo, ipIdx) => {
      if (!ipInfo.first || ipInfo.first.length < 1) {
        focusInput = `${sysIdx}-realIp-${ipIdx}-0`;
        return true;
      }
      if (!ipInfo.second || ipInfo.second.length < 1) {
        focusInput = `${sysIdx}-realIp-${ipIdx}-1`;
        return true;
      }
      if (!ipInfo.third || ipInfo.third.length < 1) {
        focusInput = `${sysIdx}-realIp-${ipIdx}-2`;
        return true;
      }
      if (!ipInfo.fourth || ipInfo.fourth.length < 1) {
        focusInput = `${sysIdx}-realIp-${ipIdx}-3`;
        return true;
      }
      if (!ipInfo.portNo || ipInfo.portNo.length < 1) {
        focusInput = `${sysIdx}-realIp-${ipIdx}-4`;
        return true;
      }
    });
    if (focusInput) return true;

    sysInfo.serviceiplist.forEach((ipInfo, ipIdx) => {
      if (!ipInfo.first || ipInfo.first.length < 1) {
        focusInput = `${sysIdx}-serviceIp-${ipIdx}-0`;
        return true;
      }
      if (!ipInfo.second || ipInfo.second.length < 1) {
        focusInput = `${sysIdx}-serviceIp-${ipIdx}-1`;
        return true;
      }
      if (!ipInfo.third || ipInfo.third.length < 1) {
        focusInput = `${sysIdx}-serviceIp-${ipIdx}-2`;
        return true;
      }
      if (!ipInfo.fourth || ipInfo.fourth.length < 1) {
        focusInput = `${sysIdx}-serviceIp-${ipIdx}-3`;
        return true;
      }
      if (!ipInfo.portNo || ipInfo.portNo.length < 1) {
        focusInput = `${sysIdx}-serviceIp-${ipIdx}-4`;
        return true;
      }
    });
    if (focusInput) return true;
  });

  return focusInput;
};

export const getFile = (file) => {
  let blob = new Blob([file.data], {
    type: file.headers['content-type'],
  });
  let fileName = decodeURIComponent(file.headers['encoded-disposition']); //파일명 디코딩
  fileName = getFileName(fileName);
  if (window.navigator.msSaveOrOpenBlob) {
    // IE 10+
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    // not IE
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.target = '_self';
    if (fileName) link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link);
  }
};

export const saveExcelFile = (file, fileName) => {
  let blob = new Blob([file.data], {
    type: file.headers['content-type'],
  });
  if (window.navigator.msSaveOrOpenBlob) {
    // IE 10+
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    // not IE
    let link = document.createElement('a');
    link.href = window.URL.createObjectURL(blob);
    link.target = '_self';
    if (fileName) link.download = fileName;
    link.click();
    window.URL.revokeObjectURL(link);
  }
};

// Excel File Name
export const getFileName = (contentDisposition) => {
  //contentDisposition 안넘어와도 테스트할거 대비해서
  // 배포시에는 분기문 제거
  if (contentDisposition) {
    let fileName = contentDisposition
      .split(';')
      .filter((ele) => ele.indexOf('filename') > -1)
      .map((ele) => ele.replace(/"/g, '').split('=')[1]);
    return fileName[0];
  } else {
    return 'unknown';
  }
};

export const phoneFormat = (num) => {
  return num.replace(/(^02.{0}|^01.{1}|[0-9]{3})([0-9]*)([0-9]{4})/, '$1-$2-$3');
};

export const getThisWeekDate = () => {
  let tmpDate = new Date();
  let first_day = new Date(tmpDate.setDate(tmpDate.getDate() - tmpDate.getDay() + 1));
  // let last_day = new Date(tmpDate.setDate(first_day.getDate() + 6));

  let startDt = transformDayFormat(first_day);
  let endDt = transformDayFormat(new Date());

  return [startDt, endDt];
};

export const getThisMonthDate = () => {
  let curDate = new Date();
  let first_day = new Date(curDate.getFullYear(), curDate.getMonth(), 1);
  // let last_day = new Date(curDate.getFullYear(), curDate.getMonth() + 1, 0);

  let startDt = transformDayFormat(first_day);
  let endDt = transformDayFormat(new Date());

  return [startDt, endDt];
};

export const getKeyValueFromObject = (obj) => {
  let objKey = null,
    objValue = null;

  Object.entries(obj).map(([key, value]) => {
    objKey = key;
    objValue = value;
  });

  return [objKey, objValue];
};

// 특수문자 체크
export const checkSpecial = (str) => {
  const regExp = /[~!@#$%^&*()_+-|<>?:;`,{}\]\[/\'\"\\\']/gi;
  if (regExp.test(str)) return true;
  else return false;
};

// 한글 체크
export const checkKor = (str) => {
  const regExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]*$/;
  if (regExp.test(str)) return true;
  else return false;
};

//한글 영문 체크
export const checkKorEng = (str) => {
  const regExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣a-zA-z]*$/;
  if (regExp.test(str)) return true;
  else return false;
};

// 영어 숫자 체크
export const checkEngNum = (str) => {
  const regExp = /^[a-zA-Z0-9]*$/;
  if (regExp.test(str)) return true;
  else return false;
};

//한글 영문 숫자 체크
export const checkKorEngNum = (str) => {
  const regExp = /^[ㄱ-ㅎ|ㅏ-ㅣ|가-힣a-zA-z0-9]*$/;
  if (regExp.test(str)) return true;
  else return false;
};
// 영어 체크
export const checkEng = (str) => {
  const regExp = /^[a-zA-Z]*$/;
  if (regExp.test(str)) return true;
  else return false;
};

// 숫자 체크
export const checkNum = (str) => {
  const regExp = /^[0-9]*$/;
  if (regExp.test(str)) return true;
  return false;
};

// 공백 체크
export const checkSpace = (str) => {
  if (str.search(/\s/) !== -1) return true;
  else return false;
};

// 드롭다운 데이터 변환(value, text)
export const transformDropdown = (list, value, name) => {
  if (list.length > 0) {
    list.forEach((el) => {
      if (Object.keys(el).includes(value) && !Object.keys(el).includes('value')) {
        el['value'] = el[value];
        delete el[value];
      }
      if (Object.keys(el).includes(name) && !Object.keys(el).includes('text')) {
        el['text'] = el[name];
        delete el[name];
      }
    });
  }
  return list;
};

export const findDsrbtrCode = (list, dsrbtrCode) => {
  return list.some((item) => item.dsrbtrCode === dsrbtrCode);
};

export const getWeekDaysFromNow = () => {
  let days = [];
  let tmpDate = new Date();
  for (let i = 0; i < 7; i++) {
    tmpDate.setDate(new Date().getDate() + i);
    days.push({ key: i, value: transformDayFormat(tmpDate), text: transformDayFormat(tmpDate) });
  }
  return days;
};

export const getCheckedValue = (docType, docList) => {
  let checked = false;
  docList &&
    docList.map((doc) => {
      if (doc.CDocType === docType || doc.CDocTypeNm === docType) {
        checked = doc.colctUseYn === '1';
      }
    });
  return checked;
};

export const getIndexOfCheckbox = (docType, docList) => {
  let idx = 0;
  docList.map((doc, index) => {
    if (doc.CDocType === docType || doc.CDocTypeNm === docType) {
      idx = index;
    }
  });
  return idx;
};

export const putSessionStorage = (key, data) => {
  if (!key || !data) return null;

  let encData = data;
  let encKey = process.env.REACT_APP_SSG_EDI_STORAGE_KEY;
  if (encKey && encKey.trim().length > 0) {
    encData = CryptoJS.AES.encrypt(JSON.stringify(data), encKey).toString();
  }
  sessionStorage.setItem(key, encData);
  return encData;
};

export const getSessionStorage = (key) => {
  if (!key) return null;

  const encData = sessionStorage.getItem(key);
  if (!encData) return null;

  let encKey = process.env.REACT_APP_SSG_EDI_STORAGE_KEY;
  if (encKey && encKey.trim().length > 0) {
    const bytes = CryptoJS.AES.decrypt(encData, encKey);
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  } else {
    return encData;
  }
};

//이용, 처리현황 버튼 조건 렌더링
export const checkRenderButton = ({ srt, sps }) => {
  // srt: statusList.CRcptType, sps: statusList.CPrcsStatus
  let modify = false;
  let cancel = false;

  if (srt === 'SRT1001' || srt === 'SRT1003') {
    if (sps === 'SPS1001') {
      modify = true;
      cancel = true;
    } else if (sps === 'SPS1213') {
      modify = true;
    }
  } else if (srt === 'SRT1005' || srt === 'SRT1006' || srt === 'SRT1007') {
    if (sps === 'SPS1001') {
      cancel = true;
    }
  }
  return { modify, cancel };
};

export const checkFileExtension = (name) => {
  if (name.split('.').length < 2) return false;
  return true;
};

// 대시 기호 체크
export const checkDash = (str) => {
  const regExp = /-/;
  if (!regExp.test(str)) return true;
  else return false;
};

// x달전 날짜 구하기 YYYY-MM-DD
export const getDayAMonthAgo = (m) => {
  let day = new Date();
  let monthOfYear = day.getMonth();
  day.setMonth(monthOfYear - m);
  day.setDate('01');
  return transformDayFormat(day);
};

//현재 달의 첫 날, 마지막날
export const getLastDayAThisMonth = (date, type) => {
  //type =0.말일,1=첫번째일

  let month = type === 1 ? date.getMonth() : date.getMonth() + 1;
  let lastDate = new Date(date.getFullYear(), month, type);

  return transformDayFormat(lastDate);
};

export const checkMenuVisible = (usableMenu, code, exec = undefined) => {
  //
  if (!usableMenu || usableMenu.length < 1) return false;

  const mainCode = code.substring(3, 5);
  const subCode = code.substring(5, 7);

  // 메인 메뉴 (subCode === '00')
  const mainMenu = usableMenu.find((menu) => menu.code.substring(3, 5) === mainCode);
  // 해당 메인 메뉴 없음 (감추기)
  if (!mainMenu) {
    return false;
  }

  // 메인 메뉴
  if (subCode === '00') {
    // exec에 값이 없는 경우는 보이고(true), 아니면 메인 메뉴에 대한 CRUDEP 확인
    return exec && exec.length > 0 ? mainMenu.exec.indexOf(exec) > -1 : true;
  }
  // 서브 메뉴
  else {
    // 서브메뉴 존재 확인
    const subMenu = mainMenu.menu.find((menu) => menu.code.substring(5, 7) === subCode);
    if (!subMenu) {
      return false;
    } else {
      // exec에 값이 없는 경우는 보이고(true), 아니면 서브 메뉴에 대한 CRUDEP 확인
      return exec && exec.length > 0 ? subMenu.exec.indexOf(exec) > -1 : true;
    }
  }
};

export const onHandleSanitizeHTML = (value, opt) => {
  let clean = sanitizeHTML(value);
  if (opt !== null) {
    clean = clean.length > opt ? clean.substr(0, opt) + '...' : clean;
  }
  return clean;
};

// 한글, 영어, 숫자, 특수기호 등 포함된 텍스트 글자수 계산
export const getLengthOfComplexText = (s, l) => {
  const u = Array.from(s);
  return u.length;
};